// extracted by mini-css-extract-plugin
export default {"banner":"update-banner_banner__xfOVV","slideIn":"update-banner_slideIn__kRauy","text":"update-banner_text__ueq7I","refreshButton":"update-banner_refreshButton__YPtQX"};